export function mapSessionMember(m: any): any {
  return {
    ...m,
    name: m.user
      ? `${m.user.firstName ?? ''} ${m.user.lastName ?? ''}`.trim()
      : (m.name ?? ''),
    email: m.user?.email ?? m.email ?? '',
  };
}
